import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const RecordsIcon: FC<IconProps> = memo(
  ({ size, width, height, ...props }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(64);
    return (
      <Svg
        viewBox="0 0 1024 1024"
        width={width ?? size}
        height={height ?? size}
        {...props}
      >
        <Path
          d="M0 0m365.714286 0l292.571428 0q365.714286 0 365.714286 365.714286l0 292.571428q0 365.714286-365.714286 365.714286l-292.571428 0q-365.714286 0-365.714286-365.714286l0-292.571428q0-365.714286 365.714286-365.714286Z"
          fill="#58C1A2"
          fillOpacity=".2"
        />
        <Path
          d="M635.245714 277.430857h-242.212571a26.075429 26.075429 0 0 1-26.038857-26.038857V179.931429c0-14.372571 11.702857-26.038857 26.038857-26.038858h242.176c14.372571 0 26.075429 11.702857 26.075428 26.038858v71.424c0 14.409143-11.702857 26.038857-26.075428 26.038857z"
          fill="#58C1A2"
        />
        <Path
          d="M731.428571 217.526857h-21.504v65.938286c0 21.76-17.590857 39.387429-39.350857 39.387428H357.632A39.350857 39.350857 0 0 1 318.244571 283.428571V217.526857h-21.504a86.893714 86.893714 0 0 0-86.893714 86.893714v448a86.893714 86.893714 0 0 0 86.893714 86.857143H731.428571a86.893714 86.893714 0 0 0 86.857143-86.893714V304.384a86.893714 86.893714 0 0 0-86.857143-86.857143z m-67.254857 438.381714H364.068571a34.925714 34.925714 0 1 1 0-69.851428h300.105143a34.925714 34.925714 0 1 1 0 69.851428z m0-137.508571H364.068571a34.925714 34.925714 0 1 1 0-69.888h300.105143a34.925714 34.925714 0 1 1 0 69.851429z"
          fill="#58C1A2"
        />
      </Svg>
    );
  },
);
